import { sortingToteIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const bulkCreateSortingTotes = {
  name: "bulkCreateSortingTotes" as const,
  input: z.object({ quantity: z.number().int().min(1).max(999) }),
  output: z.object({ toteIds: z.array(sortingToteIdFormat.schema) }),
};
